var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-error"},[_c('h3',[_vm._v("Упс!!!Ошибка получения данных с сервера!!!")]),_c('h4',[_vm._v("Данные загружены из локального файла PseudoServer.")])])
}]

export { render, staticRenderFns }